// extracted by mini-css-extract-plugin
export default {"operations":"preform-form_operations__T+uvy"};